import { render, staticRenderFns } from "./ExperienceComponent.vue?vue&type=template&id=a36d7360&scoped=true"
import script from "./ExperienceComponent.vue?vue&type=script&lang=js"
export * from "./ExperienceComponent.vue?vue&type=script&lang=js"
import style0 from "./ExperienceComponent.vue?vue&type=style&index=0&id=a36d7360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d7360",
  null
  
)

export default component.exports